export default function Dialog(theme) {
  return {
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 14,
          boxShadow: theme.customShadows.dialog,
          backgroundImage: 'none',
        },
        paperFullScreen: { borderRadius: 0 },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: theme.spacing(2.5, 3),
          fontWeight: 600,
          fontSize: theme.typography.pxToRem(18),
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: { padding: theme.spacing(2, 3) },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: { padding: theme.spacing(2, 3, 2.5) },
      },
    },
  };
}
